import React from 'react';
import {
    BaseToolbarDimension, BaseToolbarMarginOrPadding, BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson
} from 'wsc-react-custom-form';

export const Settings = () => {
    return (
        <React.Fragment>
            <BaseToolbarDimension />
            <BaseToolbarMarginOrPadding name='margin'/>
            <BaseToolbarMarginOrPadding name='padding'/>
            <BaseToolbarInputGroup>
                <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50}/>
                <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50}/>
                <BaseInput propKey='maxCount' label='数量上限' tooltipTitle='上传图片的数量上线' widthRation={50}/>
                <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50}/>
                <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
                <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
                <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />

                <BaseToolbarSelect
                    propKey='showLabel'
                    label='显示Label'
                    tooltipTitle='是否显示标签'
                    options={[
                        {value: 'true', label: '显示'},
                        {value: 'false', label: '不显示'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='disabled'
                    label='禁用编辑'
                    tooltipTitle='是否禁用表单组件'
                    options={[
                        {value: 'true', label: '禁用'},
                        {value: 'false', label: '不禁用'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='multiple'
                    label='多选'
                    tooltipTitle='可多选或单选'
                    options={[
                        {value: 'true', label: '多选'},
                        {value: 'false', label: '单选'}
                    ]}
                    widthRation={50}
                />

                <BaseToolbarJson propKey="rules"  label='校验规则'  tooltipTitle='表单组件的校验规则' widthRation={50}/>
            </BaseToolbarInputGroup>
        </React.Fragment>
    );
};
